import { IonLoading } from '@ionic/react'
import React from 'react'
import { useMediaQuery } from 'react-responsive'
import { useGetSpecialVideoList, useGetVideo } from '../../../modules/video'
import { SP_MAX_WIDTH } from '../../../setting'
import { Box } from '../../atoms'
import { commentList } from '../CommentList/factory'
import { Course } from '../Course'

export interface PageVideoSignleProps {
  videoId: string
}

export const PageVideoSingle = ({ videoId }: PageVideoSignleProps) => {
  const { video } = useGetVideo({ videoId })
  // const { videoPlayHistoryList } = useGetListVideoPlayHistory({ perPage: 16, page: 1 })
  // const { videoFavoriteList } = useGetListVideoFavorite({ perPage: 16, page: 1 })
  const { videos = [] } = useGetSpecialVideoList()

  const isSp = useMediaQuery({
    query: `(max-device-width: ${SP_MAX_WIDTH})`
  })

  return video ? (
    <Box maxWidth="100%" pb="80px">
      <Box width="100%" mb="56px">
        <Course
          video={video}
          commentList={commentList}
          pdfUrl={video.term.textbookPath ? process.env.REACT_APP_GCS_URL + video.term.textbookPath : ''}
        />
      </Box>

      {/* {videos.length > 0 && (
        <Box px={isSp ? '16px' : '0px'} pl={isSp ? '16px' : '32px'}>
          <Box mb="46" width="100%" overflow="scroll">
            <CourseCardList
              courseList={videos}
              isViewMore={true}
              title="特別動画「BASIC」"
              titleIcon="special"
              isSort={false}
            />
          </Box>
        </Box>
      )} */}

      <Box px={isSp ? '16px' : '0px'} pl={isSp ? '16px' : '32px'}>
        {/* {videoPlayHistoryList.length > 0 && (
          <Box mb="46" width="100%" overflow="scroll">
            <CourseCardList
              courseList={videoPlayHistoryList.map(item => item.video)}
              isViewMore={true}
              title="最近見た動画"
              titleIcon="eye"
              isSort={false}
            />
          </Box>
        )} */}
        {/* {videoFavoriteList.length > 0 && (
          <Box mb="46" width="100%" overflow="scroll">
            <CourseCardList
              courseList={videoFavoriteList.map(item => item.video)}
              isViewMore={true}
              title="お気に入り一覧"
              titleIcon="star"
              isSort={false}
            />
          </Box>
        )} */}
      </Box>
    </Box>
  ) : (
    <IonLoading isOpen={true} />
  )
}
